import { ProductInfo } from '@/scripts/product/product-info'
import {
    currentTargetRequired,
    qsOptional,
    qsRequired,
    targetRequired,
} from '@/scripts/core/global'

export class ProductStickyCta extends ProductInfo {
    static override htmlSelector = 'product-sticky-cta'
    form: HTMLElement
    wrapper: HTMLElement
    submitContainer: HTMLElement
    overlay: HTMLElement
    boundBodyListener: () => void
    cta: HTMLButtonElement
    primaryCta?: HTMLButtonElement
    info?: ProductInfo
    enabled: boolean
    constructor() {
        super()
        this.primaryCta = qsOptional('button[type="submit"][data-source="primary"]')
        this.form = qsRequired('[data-uc-sticky-form]', this)
        this.wrapper = qsRequired('[data-uc-sticky-wrapper]', this)
        this.overlay = qsRequired('[data-uc-sticky-overlay]', this)
        this.submitContainer = qsRequired('[data-uc-sticky-submit-container', this)
        this.cta = qsRequired('button[type="submit"]', this.submitContainer)
        this.boundBodyListener = this.bodyListener.bind(this)
        this.info = qsOptional('product-info')
        this.enabled = !!this.primaryCta && !!this.info
        if (this.primaryCta) {
            this.observePrimaryCta(this.primaryCta, this.onPrimaryCtaIntersection.bind(this))
        }

    }
    override getSiblingForm() {
        return qsOptional<ProductStickyCta>(`product-info[data-uc-product-id="${this.productId}"]`)
    }
    observePrimaryCta(
        cta: HTMLElement,
        onIntersection: (elements: IntersectionObserverEntry[], _: IntersectionObserver) => void
    ) {
        const ctaObserver = new IntersectionObserver(onIntersection)
        ctaObserver.observe(cta)
    }
    onPrimaryCtaIntersection(elements: IntersectionObserverEntry[], _: IntersectionObserver) {
        elements.forEach((element) => {
            if (element.isIntersecting) {
                this.hide()
            } else if (window.scrollY > 300) {
                this.show()
            } else {
                console.log('something off in scroll detection')
            }
        })
    }
    hide() {
        this.setAttribute('aria-hidden', 'true')
        //removeTrapFocus()
    }
    show() {
        if (this.enabled) {
            this.setAttribute('aria-hidden', 'false')
        }

        //trapFocus(this.form, this.cta)
    }
    hideForm(event: Event) {
        event.preventDefault()
        this.form.setAttribute('aria-hidden', 'true')
        this.form.style.maxHeight = '0px'
        this.overlay.classList.remove('active')
        window.setTimeout(() => {
            this.overlay.style.display = 'none'
        }, 301)
        document.documentElement.removeEventListener('click', this.boundBodyListener)
    }
    bodyListener(event: Event) {
        const currentTarget = currentTargetRequired(event)
        const target = targetRequired(event)
        if (
            this.variantRadios?.contains(currentTarget) ||
            this.variantRadios?.contains(target) ||
            this.submitContainer.contains(target) ||
            this.submitContainer.contains(currentTarget)
        ) {
            return
        }
        this.hideForm(event)
    }
}
